import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { AuthContext } from '../context/AuthContext';

const PermissionsProtectedRoute = ({ children }) => {
  const { usuario, authLoading } = useContext(AuthContext);
  const token = localStorage.getItem('token');

  if (authLoading) {
    return (
      <section className="container page-shell">
        <div className="surface-card">
          <p className="mb-0">Validando permisos de administración...</p>
        </div>
      </section>
    );
  }

  if (!token || !usuario) {
    return <Navigate to="/login" replace />;
  }

  if (!usuario.permisos_autorizados) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PermissionsProtectedRoute;
